/**
 * @author Aydin Cinar
 */

(function(app) {
    app.menu = (function() {
        var initialized = false;

        var pageWidth;


        var selectors = {
            menuToggle     : '.menu-toggle',
            menuOpen       : '#menu-open',
            menuClose      : '#menu-close',
            navList        : '.main-nav-list'
        };



        var init = function() {
            initialized = true;

            app.$objs.menuToggle   = $(selectors.menuToggle);
            app.$objs.menuOpen     = $(selectors.menuOpen);
            app.$objs.menuClose    = $(selectors.menuClose);
            app.$objs.navList      = $(selectors.navList);

            bind();
        };

        var bind = function() {

            $(window).load(function () {
                findWidth();
            });

            $(window).resize(function () {
               findWidth();
            });


            app.$objs.menuOpen.on('click',function (e) {
                e.preventDefault();
                menuOpen();
            });

            app.$objs.menuClose.on('click', function (e) {
                e.preventDefault();
                menuClose();
            });

        };

        var findWidth  = function () {
            var width = $(window).width();
            pageWidth = width;
            toggle(pageWidth);
        };

        var toggle = function (width) {

            this.width = width;

            if(width<768){
                menuClose();
            } else {
                $(app.$objs.navList).removeClass(app.classes.hidden);
            }

        };

        var menuOpen = function () {
            $(app.$objs.navList).removeClass(app.classes.hidden);
            $(app.$objs.menuClose).removeClass(app.classes.hidden);
            $(app.$objs.menuOpen).addClass(app.classes.hidden);
        };

        var menuClose = function () {
            $(app.$objs.navList).addClass(app.classes.hidden);
            $(app.$objs.menuClose).addClass(app.classes.hidden);
            $(app.$objs.menuOpen).removeClass(app.classes.hidden);
        };


        var isInitialized = function() {
            return initialized;
        };

        return {
            init:          init,
            isInitialized: isInitialized
        };
    })();

    app.registerInit('menu');
})(engelsizyasam);